/**
* *************************************************************************
*  ADOBE CONFIDENTIAL
*  ___________________
* 
*   Copyright 2017 Adobe
*   All Rights Reserved.
* 
*  NOTICE:  All information contained herein is, and remains
*  the property of Adobe and its suppliers, if any. The intellectual
*  and technical concepts contained herein are proprietary to Adobe
*  and its suppliers and are protected by all applicable intellectual
*  property laws, including trade secret and copyright laws.
*  Dissemination of this information or reproduction of this material
*  is strictly forbidden unless prior written permission is obtained
*  from Adobe.
* **************************************************************************
* 
**/'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = '/Users/kbhavani/ExC/LearnReact/exc-sdk/src/localization/withLocalization.js';
exports.withLocalization = withLocalization;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _i18n = require('./i18n');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * HOC to add i18n Consumer easly
 * @param {node} Component React component to be enhanced
 * @returns {LocalizedComponent} the React component with the added localization context
 */
function withLocalization(Component) {
  return function LocalizedComponent(props) {
    var _this = this;

    return _react2.default.createElement(
      _i18n.I18nConsumer,
      {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 12
        },
        __self: this
      },
      function (context) {
        return _react2.default.createElement(Component, Object.assign({}, props, {
          locale: context.locale,
          localeData: context.localeData,
          interpolator: context.interpolator,
          getUserLanguage: context.getUserLanguage,
          getMessage: context.getMessage,
          FormattedDateTime: context.FormattedDateTime,
          FormattedRelative: context.FormattedRelative,
          FormattedNumber: context.FormattedNumber,
          FormattedMessage: context.FormattedMessage,
          FormattedHTMLMessage: context.FormattedHTMLMessage,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 14
          },
          __self: _this
        }));
      }
    );
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@exc-ui/exc-sdk/dist/production/localization/withLocalization.js
// module id = 135
// module chunks = 0